export default {
    "breakPointXL": "1400px",
    "breakPointL": "1200px",
    "breakPointM": "1000px",
    "breakPointS": "800px",
    "breakPointXS": "500px",
    "breakPointXXS": "400px",
    "contentBreakPointXS": "400px",
    "contentBreakPointS": "500px",
    "contentBreakPointM": "650px",
    "contentBreakPointL": "900px",
    "contentBreakPointXL": "1000px",
    "contentBreakPointXXL": "1200px",
    "clippyWidth": "360px",
    "breakPointClippy": "1360px",
    "breakPointHideMenu": "800px",
    "breakPointHideMenuClippyOpen": "1000px",
    "breakPointHeightTestDrive": "790px",
    "breakPointHeightTestDrive2": "700px"
}
